import { ChevronUp, Search, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";

const CommandBox = ({ data, selectedIsFor, setSelected, placeHolder, label, nameOfSelected, isLoading, error }) => {
    const boxRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('');
    const [displayValue, setDisplayValue] = useState(label);

    const filteredData = data
        ?.filter(item => item?.title?.toLowerCase()?.includes(search?.toLowerCase()))
        ?.sort((a, b) => a.sort - b.sort);


    useEffect(() => {
        if (selectedIsFor && data){
            setDisplayValue(data?.find(item => Number(item.id) === Number(selectedIsFor))?.title)
        }else{
            setDisplayValue(label)
        }
        const hideSelect = (e) => {
            if (boxRef.current && !boxRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener('mousedown', hideSelect);
        return () => {
            document.removeEventListener("mousedown", hideSelect);
        }
    }, [search, data, selectedIsFor, displayValue, label]);

    return (
        <div className="w-full">
            <div className="space-y-2">
                <label className="block text-base text-semi-gray rtl:text-right ltr:text-left">{label}</label>
                <div className="relative" ref={boxRef}>
                    {/* trigger */}
                    <div
                        className="flex items-center justify-between w-full p-2 border rounded-lg select-ui cursor-pointer"
                        onClick={() => setIsOpen(!isOpen)}>
                        <span className="text-gray-700">{displayValue}</span>
                        <ChevronUp size={20} className={`${isOpen ? '' : 'rotate-180'} transition`} />
                    </div>

                    {/* command box content */}
                    {isOpen && (
                        <div className="absolute z-50 w-full mt-1 bg-white border rounded-lg shadow-lg">

                            {/* search */}
                            <div className="relative p-2 border-b">
                                <input
                                    type="text"
                                    placeholder={placeHolder}
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="w-full p-2 pr-8 border rounded-md"
                                    autoFocus
                                />
                                {search ?
                                    <button
                                        className="absolute top-5 left-4"
                                        onClick={() => setSearch("")}
                                    >
                                        <X size={16} className="text-gray-400" />
                                    </button>
                                    :
                                    <Search className="absolute top-5 left-4 text-gray-400"
                                        size={16} />
                                }
                            </div>
                            {
                                isLoading ?
                                    (<div className="grid gap-2 w-full p-2">
                                        {
                                            [...Array(6)].map((_, i) => (
                                                <div key={i} className="rounded-md l-load h-9 w-full"></div>
                                            ))
                                        }
                                    </div>)
                                    :
                                    error
                                        ?
                                        <button type="button"
                                            onClick={() => document.location.reload()}
                                            className="flex items-center justify-center py-4 text-red-600 w-full underline underline-offset-4">
                                            عفوا حدث خطأ ما برجاء المحاولة مجددا
                                        </button>
                                        :
                                        // طول البوكس عشان الناس متزعلش
                                        <div>
                                            <ul className="max-h-60 overflow-y-auto py-1">
                                                {filteredData?.length > 0 ? (
                                                    <>
                                                        {filteredData?.map((item, i) => (
                                                            <li key={i}
                                                                className={`px-4 py-2 cursor-pointer hover:bg-secondary-tw/5 ${Number(selectedIsFor) === item?.id ? "bg-secondary-tw/5 text-secondary-tw" : ""
                                                                    }`}
                                                                onClick={() => {
                                                                    setSelected(prev => ({
                                                                        ...prev,
                                                                        [nameOfSelected]: item?.id
                                                                    }));
                                                                    setIsOpen(false);
                                                                    setSearch("");
                                                                }}
                                                            >
                                                                {item?.title}
                                                            </li>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <li className="px-4 py-2 text-gray-500">لا يوجد نتائج</li>
                                                )}
                                            </ul>

                                            <button disabled={displayValue === label} type="button"
                                                className="w-full disabled:bg-secondary-tw/50 disabled:cursor-not-allowed grid place-items-center py-2 bg-secondary-tw text-white rounded-b-md hover:bg-secondary-tw/90"
                                                onClick={() => {
                                                    setSelected(prev => ({ ...prev, [nameOfSelected]: '' }));
                                                    setIsOpen(false);
                                                    setDisplayValue(label);
                                                }}
                                            >
                                                إعادة تعيين {label}
                                            </button>
                                        </div>
                            }
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
};
export default CommandBox;